export class UrlModel {
  public url: string;
  public relativePath?: string;

  constructor(params: UrlModel) {
    this.url = params.url;
    this.relativePath = params?.relativePath;
  }

  public static fromSDK(url: string) {
    return new UrlModel({
      url,
    });
  }
}
